module.exports = __webpack_public_path__ + "img/productIcon2.8850eea9.png";